import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { getToken } from "../../utils/getToken";

export const useGetTotalSalesQuery = ({
  timePeriod,
  customStartDate,
  customEndDate,
}: {
  timePeriod?: string;
  customStartDate?: string;
  customEndDate?: string;
}) => {
  const token = getToken();

  const params: any = {};
  if (timePeriod) params.timePeriod = timePeriod;
  if (customStartDate) params.customStartDate = customStartDate;
  if (customEndDate) params.customEndDate = customEndDate;

  return useQuery({
    queryKey: ["useGetTotalSalesQuery", params],
    queryFn: () =>
      axiosInstance
        .get("dashboard/total-sales", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        })
        .then((res) => res.data),

    enabled: !!token,
  });
};
